import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetUsersCountSlice = createSlice({
    name: "getUsersCount",
    initialState,
    reducers: {
        getUsersCountRequest(state) {
            state.loading = true;
        },
        getUsersCountRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        getUsersCountRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    getUsersCountRequest,
    getUsersCountRequestSuccess,
    getUsersCountRequestError,
} = GetUsersCountSlice.actions;

export default GetUsersCountSlice.reducer;
